// extracted by mini-css-extract-plugin
module.exports = {"boards":"Boards_boards__1afJS","input":"Boards_input__1KAI8","boardWrapper":"Boards_boardWrapper__2d35f","board":"Boards_board__11K_1"};